/** @jsx jsx */
import { jsx } from '@emotion/core'
import style from './payStyle';
import React from 'react';
import { SiteLink, usePost, useRouter, Button, ErrorMessage } from '../../../components';
import env from '../../../env';
//import { initStripe } from './payStripe';
import { CartSummary } from '../cartSummary/summary';
import { getEwayFormModel } from './ewayFormModel';
import { useStore } from '../../../store';
import { useForm } from '../../../form';

export function Pay({ cart }) {

  //const [stripe, setStripe] = React.useState(null);
  //const [card, setCard] = React.useState(null);
  //const [error, setError] = React.useState(null);

  const post = usePost();
  const { Redirect } = useRouter();
  const { dispatch } = useStore();

  const ewayFormModel = getEwayFormModel({});
  const ewayForm = useForm(ewayFormModel, {usePlaceholder:true});
  const ewayFormRender = (name) => ewayForm.renderControl(name, null);

  React.useEffect(() => {
    // const { stripe, card } = initStripe(setError)
    // setStripe(stripe);
    // setCard(card);
  }, [])

  function payNow(e) {
    
    // if (error) return;
    // stripe.createToken(card).then(function (result) {
    //   if (result.error) {
    //     setError(result.error.message);
    //   } else {
    //     setError(null);
    //     // Send the token to your server.
    //     onSubmit(result.token.id);
    //   }
    // });

    ewayForm.validateForm(e, () => {
      if(window.eCrypt){
        const value = ewayForm.getValue();
        const payment = {
          cartId : env.getDevCartId(),
          itemTotalAmount : cart.itemTotalAmount,
          cardName : value.cardHolderName,
          cardNumber : window.eCrypt.encryptValue(value.cardNumber, env.ewayClientKey),
          cardExpMM : value.cardExpiryMM,
          cardExpYY : value.cardExpiryYY,
          cvv : window.eCrypt.encryptValue(value.securityCode, env.ewayClientKey),
        }
        onSubmit(payment);
      }
    });
  }

  function onSubmit(payment) {
    post.send(env.apiBase + "/api/cart/payeway", payment);
  }

  if (post.done()) {
    env.setDevCartId(null);
    dispatch({type:'SET_STATE', payload : { cartInfo : 0 }});
    return <Redirect to={`/order-thankyou?o=${post.response.results.OrderIdToken}`} />
  }

  return <div css={style.pay}>
    <div className="row" >
      <div className="col-md-9">
        <h3>Pay by Credit Card</h3>

        <div css={style.stripeWrapper}>
          <div className="stripe-wrapper">
            {/* <div id="card-element"></div> */}
            
            <div className="row">
              <div className="col-md-6 col-12">
                {ewayFormRender('cardHolderName')}
              </div>
              <div className="col-md-6 col-12">
                {ewayFormRender('cardNumber')}
              </div>
              <div className = "col-12">
                Card Expiry
              </div>
              <div className = "col-md-4">
                {ewayFormRender('cardExpiryMM')}
              </div>
              <div className = "col-md-4">
                {ewayFormRender('cardExpiryYY')}
              </div>
              <div className = "col-12">
                Security Code
              </div>
              <div className = "col-md-4">
                {ewayFormRender('securityCode')}
              </div>
            </div>

          </div>
          
          <div css = {style.paymentInfoText}>
            Payment through encrypted gateway can be made by Visa, Mastercard or AMEX.  Please enter your credit card details to complete your order. 
            For alternative payment methods please <SiteLink to = "#contactForm" className="contact-link"> contact us </SiteLink>
          </div>

        </div>

      </div>

      <div className="col-md-3">
        <CartSummary cart={cart} />
      </div>
    </div>
    <div css={style.formActions}>
      <Button onClick={payNow} status={post.status}>Pay Now</Button>
      <ErrorMessage errors={ewayForm.errors} />
      <ErrorMessage errors={post.errors} />
    </div>
  </div>
}
